import { useSyncExternalStore } from 'react'
import {
  assinarFalhaDeGravacao,
  ultimaFalhaDeGravacao,
  limparFalhaDeGravacao,
} from '../sync/falhaDeGravacao'

// Fica ate ela fechar. Erro que some sozinho passa despercebido -- a mesma
// regra que rotuloSalvamento.ts ja segue no botao ("so o sucesso some").
export default function AvisoFalhaGravacao() {
  const falha = useSyncExternalStore(assinarFalhaDeGravacao, ultimaFalhaDeGravacao, () => null)
  if (!falha) return null

  return (
    <div
      role="alert"
      data-testid="aviso-falha-gravacao"
      className="bg-red-600 text-white px-4 py-2 flex items-start justify-between gap-3"
    >
      <div className="text-sm">
        <span className="block font-bold">Erro ao salvar — não foi gravado</span>
        <span className="block text-red-100 text-xs mt-0.5">
          {falha.tabela}: {falha.mensagem}
        </span>
        <span className="block text-red-100 text-xs mt-0.5">
          Tente de novo. Se continuar, feche e abra o app.
        </span>
      </div>
      <button
        onClick={limparFalhaDeGravacao}
        aria-label="Fechar aviso"
        className="text-white text-lg leading-none shrink-0 px-1"
      >
        ×
      </button>
    </div>
  )
}
